<button
  class="btn btn-link btn-previous d-flex px-0"
  (click)="goToPreviousPage()"
  wlAutomationId="questionnaire-pageBackButton"
>
  <fa-icon icon="arrow-left"></fa-icon>
  {{ buttonLabel }}
</button>
